<template>
  <div class="cover_container">
    <div class="coverbanner">
      <div class="fixwhile">
        <img src="../../assets/images/baidi.png" />
      </div>
      <van-swipe :autoplay="6000" :show-indicators="false" ref="swipe" @change="changebanimg">
        <van-swipe-item v-for="(image, index) in images" :key="index">
          <img :src="image" />
        </van-swipe-item>
      </van-swipe>
    </div>

    <div class="luboiconbox">
      <div class="luboiconlist" @click="clickgoto('0')">
        <div v-if="dqindex==0">
          <div class="iconsmbox">
            <img class="icon01" src="../../assets/images/guide_btn_hi_selected.png" />
            <p class="yellow">我们来了</p>
          </div>
          <div class="icon02div">
            <img class="icon02" src="../../assets/images/guide_btn_dian_selected.png" />
          </div>
        </div>
        <div v-else>
          <div class="iconsmbox">
            <img class="icon01" src="../../assets/images/guide_btn_hi_normal.png" />
            <p>我们来了</p>
          </div>
          <div class="icon02div">
            <img class="icon02" src="../../assets/images/guide_btn_dian_normal.png" />
          </div>
        </div>
      </div>
      <div class="luboiconlist" @click="clickgoto('1')">
        <div v-if="dqindex==1">
          <div class="iconsmbox">
            <img class="icon01" src="../../assets/images/guide_btn_time_selected.png" />
            <p class="yellow">10秒创建</p>
          </div>
          <div class="icon02div">
            <img class="icon02" src="../../assets/images/guide_btn_dian_selected.png" />
          </div>
        </div>
        <div v-else>
          <div class="iconsmbox">
            <img class="icon01" src="../../assets/images/guide_btn_time_normal.png" />
            <p>10秒创建</p>
          </div>
          <div class="icon02div">
            <img class="icon02" src="../../assets/images/guide_btn_dian_normal.png" />
          </div>
        </div>
      </div>
      <div class="luboiconlist" @click="clickgoto('2')">
        <div v-if="dqindex==2">
          <div class="iconsmbox">
            <img class="icon01" src="../../assets/images/guide_btn_share_selected.png" />
            <p class="yellow">一键分享</p>
          </div>
          <div class="icon02div">
            <img class="icon02" src="../../assets/images/guide_btn_dian_selected.png" />
          </div>
        </div>
        <div v-else>
          <div class="iconsmbox">
            <img class="icon01" src="../../assets/images/guide_btn_share_normal.png" />
            <p>一键分享</p>
          </div>
          <div class="icon02div">
            <img class="icon02" src="../../assets/images/guide_btn_dian_normal.png" />
          </div>
        </div>
      </div>
      <div class="luboiconlist" @click="clickgoto('3')">
        <div v-if="dqindex==3">
          <div class="iconsmbox">
            <img class="icon01" src="../../assets/images/guide_btn_card_selected.png" />
            <p class="yellow">个性名片</p>
          </div>
          <div class="icon02div">
            <img class="icon02" src="../../assets/images/guide_btn_dian_selected.png" />
          </div>
        </div>
        <div v-else>
          <div class="iconsmbox">
            <img class="icon01" src="../../assets/images/guide_btn_card_normal.png" />
            <p>个性名片</p>
          </div>
          <div class="icon02div">
            <img class="icon02" src="../../assets/images/guide_btn_dian_normal.png" />
          </div>
        </div>
      </div>
      <div class="luboiconlist" @click="clickgoto('4')">
        <div v-if="dqindex==4">
          <div class="iconsmbox">
            <img class="icon01" src="../../assets/images/guide_btn_dynamic_selected.png" />
            <p class="yellow">行业动态</p>
          </div>
          <div class="icon02div">
            <img class="icon02" src="../../assets/images/guide_btn_dian_selected.png" />
          </div>
        </div>
        <div v-else>
          <div class="iconsmbox">
            <img class="icon01" src="../../assets/images/guide_btn_dynamic_normal.png" />
            <p>行业动态</p>
          </div>
          <div class="icon02div">
            <img class="icon02" src="../../assets/images/guide_btn_dian_normal.png" />
          </div>
        </div>
      </div>
      <div class="luboiconlist" @click="clickgoto('5')">
        <div v-if="dqindex==5">
          <div class="iconsmbox">
            <img class="icon01" src="../../assets/images/guide_btn_cooperation_selected.png" />
            <p class="yellow">商机交换</p>
          </div>
        </div>
        <div v-else>
          <div class="iconsmbox">
            <img class="icon01" src="../../assets/images/guide_btn_cooperation_normal.png" />
            <p>商机交换</p>
          </div>
        </div>
      </div>
    </div>

    <div class="creatmpbtn">
      <a id="call-app" ref="callApp" href="javascript:void(0);" style="display: inline-block;float:right;">
        <input id="download-app" type="hidden" name="storeurl" value="https://android.myapp.com/myapp/detail.htm?apkName=com.xunmeng.pinduoduo&ADTAG=mobile" />
        <div class="intoR">
          <span>打开鲜枇杷</span>
        </div>
      </a>
      <a id='links' href="#" style='display:none;'></a>
    </div>

    <div class="copyright">
      <img src="../../assets/images/guide_icon_logo.png" />
      <span>鲜枇杷名片出品</span>
    </div>
    <div v-if="weixinTD" class="popBox" id="weixinTD" @click="closeWeixinTD">
      <div class="popBox-mask"></div>
      <div class="popBox-content jiant" style="clear:left; top: 10%;right:0;">
        <p style="text-align:center">请点击右上角，在浏览器打开 →</p>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { Dialog } from "vant";

Vue.use(Dialog);
export default {
  name: "appshare",
  data () {
    return {
      andurl: "", //安卓appurl
      link: "", //h5跳转
      config: {},
      images: [
        require("../../assets/images/banner_a.jpg"),
        require("../../assets/images/banner_b.jpg"),
        require("../../assets/images/banner_c.jpg"),
        require("../../assets/images/banner_d.jpg"),
        require("../../assets/images/banner_e.jpg"),
        require("../../assets/images/banner_f.jpg")
      ],
      dqindex: 0,
      weixinTD: false
    };
  },
  created () {
    var that = this;
    var u = navigator.userAgent;
    var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
    var ua = navigator.userAgent.toLowerCase();
    var isWeixin = ua.indexOf("micromessenger") != -1;
    if (isWeixin) {
      this.weixinTD = true;
    }
    var t;
    let id = that.GetQueryString("id");
    let name = that.GetQueryString("name");
    let { andurl, link } = that.getdata(id, name);
    var config = {
      scheme_IOS: andurl,
      scheme_Adr: andurl,
      download_url: link,
      timeout: 600
    };
    this.config = config;
  },
  mounted () {
    let that = this;
    let { isAndroid, isIOS, isIOS9 } = this.detectVersion();
    if (isIOS) {
      this.$refs.callApp.href = this.config.scheme_IOS;
    } else if (isIOS9) {
      /*  this.$refs.callApp.href = this.config.scheme_IOS; */
      document.getElementById("call-app").addEventListener(
        "click",
        this.iosOpenClient,
        false
      );
    } else {
      document.getElementById("call-app").addEventListener(
        "click",
        this.openclient,
        false
      );
    }
  },
  methods: {
    closeWeixinTD () {
      this.weixinTD = false;
    },
    changebanimg (e) {
      this.dqindex = e;
    },
    iosOpenClient () {
      var that = this;
      that.$refs.callApp.href = that.config.scheme_IOS;
      setTimeout(function () {
        var obj = document.getElementById('links');
        obj.href = that.config.download_url;
        obj.click();
      }, 250);
      setTimeout(function () {
        location.reload();
      }, 1000);
    },
    openclient () {
      var that = this;
      var startTime = Date.now();
      var ifr = document.createElement("iframe");
      var ua = navigator.userAgent.toLowerCase();
      //    创建ifram并指定src
      ifr.src =
        ua.indexOf("os") > 0 ? that.config.scheme_IOS : that.config.scheme_Adr;
      ifr.style.display = "none";
      document.body.appendChild(ifr);
      var t = setTimeout(function () {
        var endTime = Date.now();
        if (!startTime || endTime - startTime < that.config.timeout + 200) {
          window.location = that.config.download_url;
        } else {
        }
      }, that.config.timeout);
      window.onblur = function () {
        clearTimeout(t);
      };
    },
    detectVersion () {
      let u = navigator.userAgent;
      let ua = u.toLowerCase();
      let isAndroid, isIOS, isIOS9, version;
      if (u.indexOf("Android") > -1 || u.indexOf("Linux") > -1) {
        //android终端或者uc浏览器
        //Android系统
        isAndroid = true;
      }
      if (ua.indexOf("like mac os x") > 0) {
        //ios
        var regStr_saf = /os [\d._]*/gi;
        var verinfo = ua.match(regStr_saf);
        version = (verinfo + "").replace(/[^0-9|_.]/gi, "").replace(/_/gi, ".");
      }
      var version_str = version + "";
      if (version_str != "undefined" && version_str.length > 0) {
        version = parseInt(version);
        if (version >= 8) {
          // ios9以上
          isIOS9 = true;
        } else {
          isIOS = true;
        }
      }
      return { isAndroid, isIOS, isIOS9 };
    },
    //获取url参数
    GetQueryString (name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      var href = window.location.href;
      /*   href.replace('?from=singlemessage', ''); */
      /*  href.replace('?from=timeline', ''); */

      if (href.indexOf("?from=singlemessage") != -1) {
        href = href.replace('?from=singlemessage', '');
      }
      if (href.indexOf("?from=timeline") != -1) {
        href = href.replace('?from=timeline', '');
      }
      var r = href
        .split("?")[1]
        .substr(0)
        .match(reg); //search,查询？后面的参数，并匹配正则
      if (r != null) return unescape(r[2]);
      return null;
    },
    //判断页面
    getdata (id, name) {
      var andurl = "";
      var link = "";
      if (name == "othercart") {
        andurl = "xianpipa://other_visitcard?id=" + id;
        link = "https://h5.xianpipa.com/#/othercart?id=" + id;
      }
      if (name == "circlecontent") {
        andurl = "xianpipa://dynamic_circle?id=" + id;
        link = "https://h5.xianpipa.com/#/circlecontent?id=" + id;
      }
      if (name == "dynamic") {
        andurl = "xianpipa://dynamic_people?id=" + id;
        link = "https://h5.xianpipa.com/#/dynamic?otherrenid=" + id;
      }
      if (name == "dynamicdetails") {
        andurl = "xianpipa://dynamic_detail?id=" + id;
        link = "https://h5.xianpipa.com/#/dynamicdetails?id=" + id;
      }
      return { andurl, link };
    }
  }
};
</script>

<style scoped>
.popBox-mask {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  opacity: 0.6;
  z-index: 999;
  background-color: #000;
}

.popBox-content {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 999;
  width: 60%;
  font-size: 0.7027027027027027rem;
  border-radius: 0.7027027027027027rem;
  text-align: center;
}

.cover_container {
  background: #fff;
}
.coverbanner {
  position: relative;
  width: 100%;
  overflow: hidden;
}
.coverbanner .fixwhile {
  position: absolute;
  bottom: -9.8rem;
  left: 0;
  width: 100%;
  z-index: 1;
}
.coverbanner .fixwhile img {
  width: 100%;
}
.coverbanner .van-swipe {
}
.coverbanner .van-swipe img {
  width: 100%;
}

.luboiconbox {
  overflow: hidden;
  padding-top: 0.40540540540540543rem;
  padding-left: 0.7567567567567568rem;
}
.luboiconbox .luboiconlist {
  float: left;
}
.luboiconbox .luboiconlist .icon01 {
  width: 1.135135135135135rem;
  height: 1.135135135135135rem;
}
.luboiconbox .luboiconlist .iconsmbox {
  float: left;
  text-align: center;
}
.luboiconbox .luboiconlist .iconsmbox p {
  font-size: 0.6486486486486487rem;
  color: #c4c4c4;
  padding-top: 0.2702702702702703rem;
}
.luboiconbox .luboiconlist .iconsmbox p.yellow {
  color: #ffbd0b;
}
.luboiconbox .luboiconlist .icon02div {
  float: left;
  padding-top: 0.5405405405405406rem;
  padding-left: 0.02rem;
  padding-right: 0.02rem;
}
.luboiconbox .luboiconlist .icon02div .icon02 {
  float: left;
  width: 0.5135135135135135rem;
  height: 0.10810810810810811rem;
}

.creatmpbtn {
  margin: 0 auto;
  height: 2.4324324324324325rem;
  background: linear-gradient(90deg, #ffbd0a, #f9da5b);
  border-radius: 1.3513513513513513rem;
  text-align: center;
  line-height: 2.4324324324324325rem;
  color: #fff;
  font-size: 0.8648648648648649rem;
  margin-right: 0.2702702702702703rem;
  box-shadow: 0rem 0.08108108108108109rem 0.13513513513513514rem #ffe9ae;
  margin-top: 1rem;
  margin-left: 1rem;
  margin-right: 1rem;
}
.creatmpbtn a {
  display: block;
  width: 100%;
  height: 100%;
  color: #fff;
}

.copyright {
  display: flex;
  padding-top: 0.7rem;
  padding-bottom: 0.7rem;
  flex-flow: row nowrap;
  justify-content: center;
  bottom: 0.6756756756756757rem;
  width: 100%;
}
.copyright img {
  width: 0.972972972972973rem;
  height: 0.972972972972973rem;
}
.copyright span {
  font-size: 0.7rem;
  color: #f8b605;
  padding-top: 0.05rem;
  padding-left: 0.40540540540540543rem;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/appshare.vue